/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.security.district-users'},
});

const DistrictUsersItem = () => (
  <RouteLinkItem
    route="midas/settings/security/district-users"
    title={messages.title}
  />
);

export default DistrictUsersItem;
